<template>
  <base-card dark>
  <v-carousel>
    <v-carousel-item
      v-for="(item,i) in items"
      :key="i"
      :src="item.src"
    >
  
      <v-layout
        fill-height
        align-center
        pa-3
      >
        <v-flex
          xs12
          md7
          offset-md5
        >
          <h1 class="display-3 font-weight-light">
            The Art Of Game
          </h1>
          <div class="subheading text-uppercase pl-2 mb-4">
            Find Beauty, with your eyes
          </div>
          <v-btn
            color="primary"
            depressed
            round
            to="/Landing"
          >
            Check
          </v-btn>
        </v-flex>
      </v-layout>
      </v-carousel-item>
        </v-carousel>
  </base-card>
</template>
<script>
  export default {
    data () {
      return {
        items: [
          {
            src: 'https://cdn02.nintendo-europe.com/media/images/10_share_images/games_15/nintendo_switch_4/H2x1_NSwitch_DarkSoulsRemastered_image1600w.jpg'
          },
          {
            src: 'https://static.bandainamcoent.eu/high/dark-souls/dark-souls-hd/03-news/dshd_switch-release-date.jpg'
          },
          {
            src: 'https://live.staticflickr.com/1911/43761875090_1a06edb485_b.jpg'
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg'
          }
        ]
      }
    }
  }
</script>